<template>
  <v-dialog v-model="visible">
    <v-form v-model="is_form_valid" ref="form">
      <v-card :loading="loading">
        <v-card-title>
          Formulir Surat Masuk - {{ jenisSurat.code }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-xl>
            <v-row>
              <v-col cols="6">
                <v-menu
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  :disabled="readOnly"
                  v-if="isAdmin"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="form.tgl_masuk"
                      :rules="nonEmptyRule"
                      label="Tanggal Masuk Surat"
                      prepend-icon="mdi-calendar-range"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    locale="ID"
                    v-model="form.tgl_masuk"
                  ></v-date-picker>
                </v-menu>
                <v-autocomplete
                  :disabled="readOnly"
                  prepend-icon="mdi-counter"
                  label="Kode Klasifikasi Surat"
                  placeholder="Cari Kode"
                  v-model="form.kode"
                  item-value="kode"
                  item-text="kode_jenis"
                  :items="kodeSurat"
                  :rules="nonEmptyRule"
                  :search-input.sync="kodeSuratQuery"
                  :loading="$store.state.loadingKodeSurat"
                  :no-data-text="
                    $store.state.loadingKodeSurat
                      ? 'Mencari Kode Surat...'
                      : 'Tidak ada data. Hubungin admin untuk menambahkan kode surat.'
                  "
                  :hide-no-data="!kodeSuratQuery"
                ></v-autocomplete>
                <v-text-field
                  :readonly="readOnly"
                  v-model="form.pengirim"
                  :rules="nonEmptyRule"
                  label="Pengirim"
                  placeholder="Nama pengirim atau asal surat"
                  prepend-icon="mdi-account-box"
                ></v-text-field>
                <v-textarea
                  :readonly="readOnly"
                  v-model="form.perihal"
                  :rules="nonEmptyRule"
                  label="Perihal"
                  placeholder="Masukkan perihal surat"
                  prepend-icon="mdi-help-circle-outline"
                  rows="2"
                ></v-textarea>
                <v-layout row>
                  <v-flex class="py-1" xs6 md6 lg6 xl6>
                    <v-menu
                      :close-on-content-click="true"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                      :disabled="readOnly"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="form.tgl_surat"
                          :rules="nonEmptyRule"
                          label="Tanggal Surat"
                          prepend-icon="mdi-calendar-range"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        locale="ID"
                        v-model="form.tgl_surat"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex class="py-1" xs6 md6 lg6 xl6>
                    <v-text-field
                      :readonly="readOnly"
                      v-model="form.no"
                      :rules="nonEmptyRule"
                      label="Nomor Surat"
                      placeholder="Masukkan nomor surat"
                      prepend-icon="mdi-numeric"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-autocomplete
                  prepend-icon="mdi-account-multiple"
                  label="Tujuan Surat"
                  v-model="form.tujuan"
                  item-value="id"
                  item-text="name"
                  :items="$store.state.pejabats"
                  return-object
                  multiple
                  chips
                  deletable-chips
                  :menu-props="{ closeOnContentClick: true }"
                  readonly
                ></v-autocomplete>
                <v-autocomplete
                  v-model="form.tembusan"
                  item-value="id"
                  item-text="name"
                  :items="$store.state.pejabats"
                  prepend-icon="mdi-account-multiple-check"
                  label="Tembusan Surat"
                  return-object
                  multiple
                  chips
                  deletable-chips
                  :menu-props="{ closeOnContentClick: true }"
                ></v-autocomplete>
              </v-col>
              <v-col cols="6">
                <v-layout row v-if="isEvent">
                  <v-flex class="py-1" xs6 md6 lg6 xl6>
                    <v-menu
                      :disabled="readOnly"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="form.tgl"
                          :rules="isAgenda ? nonEmptyRule : []"
                          label="Tanggal Undangan"
                          placeholder="Tanggal Mulai"
                          prepend-icon="mdi-calendar-range"
                          readonly
                          :clearable="!isAgenda"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        locale="ID"
                        v-model="form.tgl"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex class="py-1" xs6 md6 lg6 xl6>
                    <v-menu
                      :disabled="readOnly"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="form.tgl_selesai"
                          label="Sampai Tanggal"
                          placeholder="Tanggal Selesai"
                          prepend-icon="mdi-calendar-range"
                          readonly
                          clearable
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        locale="ID"
                        v-model="form.tgl_selesai"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                </v-layout>
                <v-layout row v-if="isEvent">
                  <v-flex class="py-1 picker-container" xs6 md6 lg6 xl6>
                    <label class="picker-label" for="waktu">Waktu Mulai</label>
                    <datepicker
                      v-model="form.waktu"
                      placeholder="HH:mm"
                      type="time"
                      :minute-step="5"
                      format="HH:mm"
                      value-type="format"
                      :disabled="readOnly"
                      :input-class="{
                        'mx-input': true,
                        'error-input': errors.has('waktu')
                      }"
                      @change="errors.clear('waktu')"
                    >
                      <template slot="icon-calendar">
                        <v-icon small>mdi-clock-outline</v-icon>
                      </template>
                    </datepicker>
                    <span class="error-helper">{{ errors.get('waktu') }}</span>
                  </v-flex>
                  <v-flex class="py-1 picker-container" xs6 md6 lg6 xl6>
                    <label class="picker-label">Waktu Selesai</label>
                    <datepicker
                      v-model="form.waktu_selesai"
                      placeholder="HH:mm"
                      type="time"
                      :minute-step="5"
                      format="HH:mm"
                      value-type="format"
                      :disabled="readOnly"
                    >
                      <template slot="icon-calendar">
                        <v-icon small>mdi-clock-outline</v-icon>
                      </template>
                    </datepicker>
                  </v-flex>
                </v-layout>
                <v-text-field
                  :readonly="readOnly"
                  v-if="isEvent"
                  v-model="form.tempat"
                  :rules="isAgenda ? nonEmptyRule : []"
                  label="Lokasi Acara"
                  placeholder="Lokasi atau tempat acara dilaksanakan"
                  prepend-icon="mdi-map-marker"
                ></v-text-field>
                <v-layout row>
                  <v-flex class="py-1" xs6 md6 lg6 xl6>
                    <v-file-input
                      v-if="!readOnly"
                      v-model="form.lampiran"
                      accept=".pdf,.jpg,.png"
                      display-size
                      counter
                      multiple
                      label="Arsip Surat"
                      placeholder="pdf, jpg atau png"
                      prepend-icon="mdi-file-document-outline"
                    ></v-file-input>
                  </v-flex>
                  <v-flex class="py-1" xs6 md6 lg6 xl6>
                    <v-select
                      label="Jenis Surat"
                      v-model="form.is_tembusan"
                      :items="optionsJenis"
                      item-value="value"
                      item-text="name"
                    ></v-select>
                  </v-flex>
                </v-layout>
                <v-textarea
                  :readonly="readOnly"
                  label="Ringkasan"
                  placeholder="Masukkan Ringkasan Isi Surat"
                  v-model="form.ringkasan"
                  :rules="nonEmptyRule"
                  prepend-icon="mdi-information-outline"
                  rows="2"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text v-if="!loading" @click="hide">
            Tutup
          </v-btn>
          <v-btn color="green darken-1" text :loading="loading" @click="submit">
            Simpan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import { saveSuratMasuk } from '@/services/surat'
import Errors from '@/utils/errors'
import { debounce } from 'lodash'

const initialForm = {
  id: null,
  ringkasan: '',
  tgl_masuk: moment().format('YYYY-MM-DD'),
  kode: '',
  pengirim: '',
  perihal: '',
  tgl_surat: moment().format('YYYY-MM-DD'),
  no: '',
  tgl: null,
  tgl_selesai: null,
  waktu: null,
  waktu_selesai: null,
  tempat: '',
  lampiran: [],
  tujuan_lain: '',
  is_tembusan: false,
  jenis_surat_id: null,
  tujuan: [],
  tembusan: []
}

export default {
  name: 'surat-masuk-form',
  data() {
    return {
      visible: false,
      is_form_valid: false,
      loading: false,
      nonEmptyRule: [v => !!v || 'tidak boleh kosong'],
      nonEmptyFileRule: [value => !value.length == 0 || 'harus dipilih'],
      optionsJenis: [
        { value: false, name: 'Asli' },
        { value: true, name: 'Tembusan' }
      ],
      jenisSurat: {
        id: null,
        code: ''
      },
      form: { ...initialForm },
      errors: new Errors(),
      kodeSuratQuery: ''
    }
  },
  mounted() {},
  watch: {
    kodeSuratQuery: debounce(function(val) {
      this.searchKodeSurat(val)
    }, 500)
  },
  computed: {
    ...mapGetters(['isAdmin']),
    isAgenda() {
      return this.jenisSurat.code.toLowerCase() === 'undangan'
    },
    readOnly() {
      return false
    },
    isEvent() {
      return this.jenisSurat.is_event
    },
    editMode() {
      return this.form.id !== null
    },
    kodeSurat() {
      return this.$store.state.kodeSurat.data.map(k => ({
        kode: k.kode,
        kode_jenis: `${k.kode} - ${k.jenis}`
      }))
    }
  },
  methods: {
    searchKodeSurat(q = '') {
      this.$store.dispatch('fetchKodeSurat', q)
    },
    show(jenis, data = initialForm) {
      this.jenisSurat = jenis
      this.form = { ...data }
      const atasan = this.$store.state.user.atasan
      if (atasan) {
        this.form.tujuan = [atasan[0]]
      }
      this.form.waktu = data.waktu
        ? moment(data.waktu, 'HH:mm:ss').format('HH:mm')
        : null
      this.form.waktu_selesai = data.waktu_selesai
        ? moment(data.waktu_selesai, 'HH:mm:ss').format('HH:mm')
        : null
      this.form.lampiran = []
      this.visible = true
    },
    hide() {
      this.$nextTick(() => {
        this.$refs.form.resetValidation()
      })
      this.visible = false
      this.form = { ...initialForm }
    },
    async submit() {
      if (!this.$refs.form.validate()) {
        return
      }
      try {
        this.loading = true
        let data = { ...this.form }
        data.is_tembusan = data.is_tembusan ? 1 : 0
        data.jenis_surat_id = this.jenisSurat.id
        data.tujuan = this.form.tujuan.map(tj => tj.id)
        data.tembusan = this.form.tembusan.map(tb => tb.id)
        await saveSuratMasuk(data)
        this.hide()
        this.$emit('handle-snackbar', 'Surat berhasil disimpan', 'success')
        this.$emit('submited')
      } catch (error) {
        this.errors.record(error.data || {})
        this.$emit('handle-snackbar', 'Surat gagal disimpan!', 'error')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.picker-container {
  padding-left: 2.8rem !important;
  margin-bottom: 0.5rem;
}
.picker-label {
  font-size: 0.75rem;
}
.mx-datepicker {
  width: 100%;
}
</style>
